//
// # OverwriteDialog
//
// Confirmation dialog shown when creating a design would overwrite
// an existing design in the depot.
//

import React, { useCallback } from "react";
import { Modal } from "./Modal/Modal";

interface OverwriteDialogProps {
  readonly designPath: string;
  readonly detail?: string;
  readonly onOverwrite: () => void;
  readonly onCancel: () => void;
}

export function OverwriteDialog({
  designPath,
  detail,
  onOverwrite,
  onCancel,
}: OverwriteDialogProps) {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
        e.preventDefault();
        onOverwrite();
      }
    },
    [onOverwrite]
  );

  return (
    <Modal open={true} onClose={onCancel} title="Design already exists">
      <div onKeyDown={handleKeyDown}>
        <p
          className="text-[13px] mb-5 leading-relaxed"
          style={{ color: "var(--color-ide-text-secondary)" }}
        >
          <code
            className="px-1.5 py-0.5 rounded text-[12px]"
            style={{
              backgroundColor: "var(--color-ide-surface-2)",
              color: "var(--color-ide-text)",
            }}
          >
            {designPath}
          </code>{" "}
          already exists. Overwrite?
        </p>
        {detail && (
          <p
            className="text-[13px] mb-5 leading-relaxed"
            style={{ color: "var(--color-ide-text-secondary)" }}
          >
            {detail}
          </p>
        )}

        <div className="flex justify-end gap-2">
          <button
            onClick={onCancel}
            className="px-4 py-1.5 text-[13px] rounded border cursor-pointer bg-transparent"
            style={{
              borderColor: "var(--color-ide-border)",
              color: "var(--color-ide-text)",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onOverwrite}
            className="px-4 py-1.5 text-[13px] rounded border-none cursor-pointer"
            style={{
              backgroundColor: "#dc2626",
              color: "#ffffff",
            }}
          >
            Overwrite
          </button>
        </div>
      </div>
    </Modal>
  );
}
